import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom'
import Dotdotdot from 'react-dotdotdot'

class InnovationCard extends Component {
    render() {
        const {id, cover, name, detail, category, short_description} = this.props.innovation
        let tags = category.split(",")
        return (
            <div className="innovation-card-wrap is-33 is-md-50 is-sm-100">
                <div className="innovation-card gapr-24 sm-gapr-0 gapb-24">
                    <div className="innovation-image-wrap gapb-24">
                        <img src={cover} className="innovation-image" alt="Innovation wrap"/>
                    </div>
                    <Dotdotdot clamp={2} className="innovation-name-wrap gapb-18">
                        <Link className="innovation-name" to={`/innovations/${id}`}>{name}</Link>
                    </Dotdotdot>
                    <Dotdotdot clamp={4} className="innovation-detail-wrap">
                        <div>{short_description}</div>
                    </Dotdotdot>
                    <div className="innovation-tags-wrap">
                        <img className="gapr-12" src="/resources/images/ic-tags.svg" alt="Tags Icon"/>
                        <div className="gapr-8">
                            <Dotdotdot clamp={1}>
                                {
                                    tags.map((tag, index) => (
                                        <Fragment key={index}>
                                            <Link to="/innovations">{tag}</Link><span>/</span>
                                        </Fragment>
                                    ))
                                }
                            </Dotdotdot>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InnovationCard;
